export class Queue {
    constructor(attemptFlushHandler) {
        this._q = [];
        this.push = (v) => {
            this._q.push(v);
            this._attemptFlushHandler();
        };
        this.flush = (filterFn) => {
            const spliced = [];
            for (const item of this._q) {
                if (filterFn == null || filterFn(item)) {
                    spliced.push(...this._q.splice(this._q.indexOf(item), 1));
                }
            }
            return spliced;
        };
        this.length = () => this._q.length;
        this._attemptFlushHandler = attemptFlushHandler;
    }
}
